import Utils from './utils'
import Constants from './constants'

const THEME = Object.freeze({
    DARK: Symbol("dark-theme"),
    LIGHT: Symbol("light"),
});

export default class Theme {
    // Get the theme depending on the time of day
    static getTheme() {
        return (Utils.isDay()) ? THEME.LIGHT : THEME.DARK;
    }

    // PRAGMA MARK :- getThemeX
    // NOTE: Make sure that all the getThemeX methods return non-nil values

    // Theme for base-class
    static getThemeBaseClass() {
        switch (this.getTheme()) {
            case THEME.DARK:
                return Constants.DARK_THEME_CLASS;
            case THEME.LIGHT:
                return Constants.LIGHT_THEME_CLASS
            default:
                return Constants.LIGHT_THEME_CLASS
        }
    }

    // Theme for background class for the body tag. NOTE: It should not be ""
    static getThemeBodyClass() {
        switch (this.getTheme()) {
            case THEME.DARK:
                return "dark-body-theme";
            case THEME.LIGHT:
                return "light-body-theme";
            default:
                return "light-body-theme";
        }
    }

    static getAllThemesBodyClasses() {
        return [
            "light-body-theme",
            "dark-body-theme"
        ]
    }

    // Theme for loader-base
    static getThemeLoaderBase() {
        switch (this.getTheme()) {
            case THEME.DARK:
                return "dark-loader-theme"
            case THEME.LIGHT:
                return "light-loader-theme";
            default:
                return "light-loader-theme";
        }
    }

    // Theme for tool-tip flavor
    static getThemeToolTipFlavor() {
        switch (this.getTheme()) {
            case THEME.DARK:
                return "temperature-tooltip-dark"
            case THEME.LIGHT:
                return "temperature-tooltip-light"
            default:
                return "temperature-tooltip-light"
        }
    }

    // Theme for back-btn image for location-picker page
    static getThemeBackBtnForLocationPicker() {
        switch (this.getTheme()) {
            case THEME.DARK:
                return "image/back-btn-dark.svg"
            case THEME.LIGHT:
                return "image/back-btn.svg"
            default:
                return "image/back-btn.svg"
        }
    }

    // Theme for location-picker bg image
    static getThemeLocationPickerBgImage() {
        switch (this.getTheme()) {
            case THEME.DARK:
                return "image/location-picker-bg-dark.jpg"
            case THEME.LIGHT:
                return "image/location-picker-bg.png"
            default:
                return "image/location-picker-bg.png"
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/theme.js